export default __webpack_public_path__ + "static/media/soprano.b6f71b6f.png";